import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";

// Значки принимаемых платёжных систем — требование банка-эквайера к сайту
// (подвал и страница «Оплата»). Рисуем inline SVG, без внешних картинок.
function Badge(t0) {
  const $ = _c(3);
  const {
    label,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== label) {
    t1 = <span role="img" aria-label={label} title={label} className="flex h-6 w-10 items-center justify-center rounded-[4px] border border-[#E5E5E5] bg-white">{children}</span>;
    $[0] = children;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function PaymentBadges(t0) {
  const $ = _c(8);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-wrap items-center gap-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Badge label={"\u041C\u0438\u0440"}><svg viewBox="0 0 34 12" className="h-[10px]" aria-hidden="true"><text x="17" y="10.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="12" fill="#0F754E">МИР</text></svg></Badge>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Badge label="Visa"><svg viewBox="0 0 34 12" className="h-[10px]" aria-hidden="true"><text x="17" y="10.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="12" fill="#1A1F71">VISA</text></svg></Badge>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Badge label="Mastercard"><svg viewBox="0 0 24 15" className="h-[14px]" aria-hidden="true"><circle cx="8" cy="7.5" r="7" fill="#EB001B" /><circle cx="16" cy="7.5" r="7" fill="#F79E1B" /><path d="M12 1.76a7 7 0 0 1 0 11.48a7 7 0 0 1 0-11.48z" fill="#FF5F00" /></svg></Badge>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Badge label={"\u0421\u0438\u0441\u0442\u0435\u043C\u0430 \u0431\u044B\u0441\u0442\u0440\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"}><svg viewBox="0 0 34 12" className="h-[10px]" aria-hidden="true"><text x="17" y="10.5" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="12" fill="#1D1346">СБП</text></svg></Badge>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1) {
    t6 = <div className={t1}>{t2}{t3}{t4}{t5}</div>;
    $[6] = t1;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}